<!-- <h3 i18n='New contact heading for contact modal@@customerOverviewComponent.modalTitle.editReminder'>Edit Reminder</h3> -->

<app-workspace-form [form]="updateReminderForm"
                    [formName]="'updateReminderForm'"
                    [pageTitle]="pageTitle"
                    [isFormValid]="!customer.isDuplicate"
                    [spinnerName]="spinnerName"
                    [submitButtonText]="buttonsTranslations.i18nSubmit"
                    [cancelButtonText]="buttonsTranslations.i18nBack"
                    (cancelButtonEvent)="sidebarOpenedChange.emit($event)"
                    (submitButtonEvent)="updateReminder()">
  <ng-container *ngIf="!pageLoading">
    <div app-form-field-textarea
         [control]="updateReminderForm.get('text')"
         [label]="reminderTranslations.i18nComment">
    </div>
    <div app-form-field-datepicker
         [future]="true"
         [control]="updateReminderForm.get('deadline')"
         [placeholder]="reminderTranslations.i18nDeadline"
         [label]="reminderTranslations.i18nDeadline">
    </div>
    <div app-form-field-select
         [control]="updateReminderForm.get('status')"
         [label]="flTranslations.i18nStatus"
         [array]="availableStatuses"
         [preselectedValue]="preselectedValue">
    </div>
    <div app-form-field-select
         [control]="updateReminderForm.get('owner')"
         [label]="flTranslations.i18nOwner"
         [textKey]="'fullName'"
         [valueKey]="'id'"
         [array]="possibleOwnersList">
    </div>

    <div class="esf-submit-row__item" *ngIf="!attachmentLoading && this.currentReminder.attachment">
      <button class="esf-button esf-button--simple"
              (click)="downloadAttachment()"
              [disabled]="currentReminder.attachment == null">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-download"></use>
        </svg>
        <span class="esf-button__icon-text">{{ file?.originalName }}</span>
      </button>
    </div>
    <div class="esf-main-sidebar__content">
      <app-spinner [name]="spinnerAttachmentLoadName" [(show)]="attachmentLoading"></app-spinner>
    </div>
  </ng-container>
  <div class="esf-main-sidebar__content">
    <app-spinner [name]="spinnerLoadName" [(show)]="pageLoading"></app-spinner>
  </div>
</app-workspace-form>
